import { render, staticRenderFns } from "./ShareHolderList.vue?vue&type=template&id=1171e82d"
import script from "./ShareHolderList.vue?vue&type=script&lang=ts"
export * from "./ShareHolderList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports